/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamRevisionPublish202,
  PostApiV1ExamRevisionPublish400,
  PostApiV1ExamRevisionPublish401,
  PostApiV1ExamRevisionPublish404,
  PostApiV1ExamRevisionPublish500,
  PostApiV1ExamRevisionPublishMutationRequest,
  PostApiV1ExamRevisionPublishMutationResponse,
} from "../../types/examRevisionController/PostApiV1ExamRevisionPublish.ts";
import { publishBotExamViewModelSchema } from "../publishBotExamViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamRevisionPublish202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionPublish202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamRevisionPublish400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionPublish400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamRevisionPublish401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionPublish401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamRevisionPublish404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionPublish404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamRevisionPublish500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionPublish500>;

export const postApiV1ExamRevisionPublishMutationRequestSchema = z.lazy(
  () => publishBotExamViewModelSchema,
) as unknown as ToZod<PostApiV1ExamRevisionPublishMutationRequest>;

export const postApiV1ExamRevisionPublishMutationResponseSchema = z.lazy(
  () => postApiV1ExamRevisionPublish202Schema,
) as unknown as ToZod<PostApiV1ExamRevisionPublishMutationResponse>;
